<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">保险公司名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
           
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建保险公司</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <!-- <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column> -->
                <el-table-column
                type="index"
                width="80"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="保险公司名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="fee"
                label="公估费(全案)"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="qasx"
                label="全案时效"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ddFee"
                label="公估费(单点)"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ddsx"
                label="单点时效"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="appId"
                label="AppId"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="appSecret"
                label="AppSecret"
                align="center"
                >
                </el-table-column>
                
                
                <el-table-column
                fixed="right"
                label="操作"
                width="240px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCompanyTip(scope.row)">删除</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="productDetail(scope.row)">险种</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增保险公司" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        保险公司名称:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        全案公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.fee" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        全案时效(天):
                    </div>
                    <div class="value">
                        <el-input v-model="addData.qasx" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        单点公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.ddFee" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单点时效(天):
                    </div>
                    <div class="value">
                        <el-input v-model="addData.ddsx" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>

                <div class="item">
                    <el-checkbox v-model="addData.uploadImage">是否上传图片</el-checkbox>
                </div>
                <div class="item">
                    <el-checkbox v-model="addData.uploadPdf">是否上传pdf</el-checkbox>
                </div>
                <div class="item">
                    <el-checkbox v-model="addData.isCaseTaskComplete">是否可新增完成案件</el-checkbox>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addCompany">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑保险公司" width="600px">
            <div class="dialog">
                
                <div class="item">
                    <div class="label">
                        保险公司名称:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        全案公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.fee" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        全案时效(天):
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.qasx" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        单点公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.ddFee" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单点时效(天):
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.ddsx" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                 <div class="item">
                    <el-checkbox v-model="updateData.uploadImage">是否上传图片</el-checkbox>
                </div>
                <div class="item">
                    <el-checkbox v-model="updateData.uploadPdf">是否上传pdf</el-checkbox>
                </div>
                <div class="item">
                    <el-checkbox v-model="updateData.isCaseTaskComplete">是否可新增完成案件</el-checkbox>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateCompany">确 定</el-button>
                </div>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isProductShow" :title="title+'——险种'" width="800px">
            <div class="dialog">
                <div class="handle">
                    <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingProductData()">刷新列表</el-button>
                    <div>
                        <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddProductDialog=true">新增险种</el-button>
                    </div>
                </div>
                <el-table
                    :data="productList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="80"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="保险公司险种"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="180px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateCompanyProductShow(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCompanyProductTip(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
               
                <div slot="footer" class="dialog-footer" style="margin-top:25px">
                    <el-button @click="isProductShow = false">取 消</el-button>
                    <!-- <el-button type="primary" @click="updateCompanyProduct">确 定</el-button> -->
                </div>
            </div>
        </el-dialog>


        
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddProductDialog" title="新增险种" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        保障产品名称:
                    </div>
                    <div class="value">
                        <el-input v-model="addProductData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddProductDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addCompanyProduct">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateProductDialog" title="编辑险种" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        保障产品名称:
                    </div>
                    <div class="value">
                        <el-input v-model="updateProductData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateProductDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateCompanyProduct">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            selectedOptions:[],
            parentDialog:false,
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            parentName:'',
            addData:{},
            updateData:{},
            tableData:[],
            isProductShow:false,
            title:"",
            id:'',

            addProductData:{},
            isAddProductDialog:false,
            updateProductData:{},
            isUpdateProductDialog:false,
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
       
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.queryCompanyPage(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                Name:'',
                Province:'',
                City:'',
                Area:'',
                page:1,
                pageSize:10,
            },
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async addCompany(){
            this.addData.fee = parseFloat(this.addData.fee);
            this.addData.qasx = parseFloat(this.addData.qasx);
            this.addData.ddsx = parseFloat(this.addData.ddsx);
            this.addData.ddFee = parseFloat(this.addData.ddFee);
            let res  = await api.addCompany(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData={
                    fee:null,
                    qasx:null,
                    ddsx:null,
                    ddFee:null,
                    uploadImage:false,
                    uploadPdf:false,
                    name:null,
                    isCaseTaskComplete:false,
                };
                this.isAddDialog = false;
            }
           
        
        },
        
        async updateCompany(){
            this.updateData.fee = parseFloat(this.updateData.fee);
            this.updateData.qasx = parseFloat(this.updateData.qasx);
            this.updateData.ddsx = parseFloat(this.updateData.ddsx);
            this.updateData.ddFee = parseFloat(this.updateData.ddFee);

            let res  = await api.updateCompany(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }
            this.updateData = {};
            this.area = [];
        },
        async isUpdateDialogShow(row){
            
            this.isUpdateDialog = true;
            this.updateData = row;
           
        },
        deleteCompanyTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCompany(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCompany(row){
            console.log(row.id);
            let res  = await api.deleteCompany(row.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async productDetail(row){
            console.log(row);
            this.isProductShow = true;
            this.id = row.id;
            this.title = row.name;
            let res  = await api.queryCompanyProduct(row.id);
            this.productList = res.data.data;
            this.$forceUpdate();
        },
        async loadingProductData(){
            this.productDetail({id:this.id,name:this.title})
        },

        async addCompanyProduct(){
            this.addProductData.bzCompanyId = this.id;
            let res  = await api.addCompanyProduct(this.addProductData);
            if(res.data.code == '200') {
                this.$message({
                    message: '新增成功',
                    type: 'success'
                });
                this.isAddProductDialog = false;
                this.addProductData.name = ''
                this.loadingProductData();
            }
        },
        async isUpdateCompanyProductShow(row){
            console.log(row);
            this.updateProductData = row;
            this.isUpdateProductDialog = true;
        },
        async updateCompanyProduct(){
            let res = await api.updateCompanyProduct(this.updateProductData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isUpdateProductDialog = false;
                this.loadingProductData();
            }
        },
        deleteCompanyProductTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCompanyProduct(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCompanyProduct(row){
            let res = await api.deleteCompanyProduct(row.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingProductData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
